import { render } from "./TourPageView.vue?vue&type=template&id=0c8b4aca"
import script from "./TourPageView.vue?vue&type=script&lang=js"
export * from "./TourPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__